import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardTokenService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { take, tap } from 'rxjs/operators';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@ngx-translate/core';

function CashBackToggleComponent_label_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ecash.cashback.toggle.on"), " ");
} }
function CashBackToggleComponent_label_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ecash.cashback.toggle.off"), " ");
} }
function CashBackToggleComponent_p_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ecash.cashback.toggle.error"), " ");
} }
const _c0 = function (a0) { return { checked: a0 }; };
class CashBackToggleComponent {
    constructor(cardTokenService) {
        this.cardTokenService = cardTokenService;
        this.disableToggle = false;
        this.enableAPICall = true;
        this.showError = false;
    }
    ngOnInit() {
        this.cardTokenService
            .fetchCardTokenStatus()
            .pipe(take(1), tap((status) => (this.turnOn = status)))
            .subscribe();
    }
    /** Toggles credit cashback on toggle change.
     * If the promise fails, toggle the UI back without calling the API again, and display error message */
    toggleCredit() {
        if (this.enableAPICall) {
            this.cardTokenService
                .setCardTokenStatus(this.turnOn)
                .catch(() => {
                this.enableAPICall = false;
                this.showError = true;
                this.turnOn = false;
            })
                .then(() => (this.enableAPICall = true));
        }
    }
}
CashBackToggleComponent.ɵfac = function CashBackToggleComponent_Factory(t) { return new (t || CashBackToggleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.CardTokenService)); };
CashBackToggleComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CashBackToggleComponent, selectors: [["fgbcl-cash-back-toggle"]], inputs: { disableToggle: "disableToggle" }, decls: 12, vars: 11, consts: [[1, "cash-back-container", "d-flex", "flex-column", "justify-content-center", "align-items-end"], [1, "d-flex", "w-100", "justify-content-between", "align-items-center"], ["id", "cashback-label", 1, "cash-back-toggle-description", "mb-0"], [1, "d-flex", "flex-row", "align-items-center"], ["class", "cash-back-toggle-label-on text-success font-size-12 font-weight-bold mb-0 mr-1", 4, "ngIf"], ["class", "cash-back-toggle-label-off text-danger font-size-12 font-weight-bold mb-0 mr-1", 4, "ngIf"], [1, "cashback-toggle", 3, "ngClass"], ["type", "checkbox", "role", "switch", "aria-labelledby", "cashback-label", 1, "cashback-toggle-input", 3, "disabled", "ngModel", "ngModelChange", "change"], [1, "cashback-toggle-slider"], ["class", "error text-danger pb-1", 4, "ngIf"], [1, "cash-back-toggle-label-on", "text-success", "font-size-12", "font-weight-bold", "mb-0", "mr-1"], [1, "cash-back-toggle-label-off", "text-danger", "font-size-12", "font-weight-bold", "mb-0", "mr-1"], [1, "error", "text-danger", "pb-1"]], template: function CashBackToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵtemplate(6, CashBackToggleComponent_label_6_Template, 3, 3, "label", 4);
        ɵngcc0.ɵɵtemplate(7, CashBackToggleComponent_label_7_Template, 3, 3, "label", 5);
        ɵngcc0.ɵɵelementStart(8, "label", 6);
        ɵngcc0.ɵɵelementStart(9, "input", 7);
        ɵngcc0.ɵɵlistener("ngModelChange", function CashBackToggleComponent_Template_input_ngModelChange_9_listener($event) { return ctx.turnOn = $event; })("change", function CashBackToggleComponent_Template_input_change_9_listener() { return ctx.toggleCredit(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(10, "span", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, CashBackToggleComponent_p_11_Template, 3, 3, "p", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 7, "ecash.cashback.toggle.label"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.turnOn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.turnOn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c0, ctx.turnOn));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", ctx.disableToggle)("ngModel", ctx.turnOn);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc3.CheckboxControlValueAccessor, ɵngcc3.NgControlStatus, ɵngcc3.NgModel], pipes: [ɵngcc4.TranslatePipe], styles: ["[_nghost-%COMP%]{width:100%}.cash-back-container[_ngcontent-%COMP%]{min-height:2rem}.error[_ngcontent-%COMP%]{font-size:.625rem;margin:0}.cashback-toggle[_ngcontent-%COMP%]{position:relative;display:inline-block;width:43px;height:20px;margin-bottom:0}.cashback-toggle[_ngcontent-%COMP%]   .cashback-toggle-slider[_ngcontent-%COMP%]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;transition:.4s;border-radius:20px}.cashback-toggle[_ngcontent-%COMP%]   .cashback-toggle-slider[_ngcontent-%COMP%]:before{position:absolute;content:\"\";height:20px;width:20px;transition:.4s;border-radius:50%;box-shadow:0 0 6px rgba(0,0,0,.1607843137254902)}.cashback-toggle[_ngcontent-%COMP%]   .cashback-toggle-input[_ngcontent-%COMP%]:checked + .cashback-toggle-slider[_ngcontent-%COMP%]:before{transform:translateX(23px)}.cashback-toggle[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{opacity:0;width:0;height:0}"] });
CashBackToggleComponent.ctorParameters = () => [
    { type: CardTokenService }
];
CashBackToggleComponent.propDecorators = {
    disableToggle: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CashBackToggleComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-cash-back-toggle',
                template: "<div class=\"cash-back-container d-flex flex-column justify-content-center align-items-end\">\r\n  <div class=\"d-flex w-100 justify-content-between align-items-center\">\r\n    <label id=\"cashback-label\" class=\"cash-back-toggle-description mb-0\">{{ 'ecash.cashback.toggle.label' | translate }}</label>\r\n    <div class=\"d-flex flex-row align-items-center\">\r\n      <label class=\"cash-back-toggle-label-on text-success font-size-12 font-weight-bold mb-0 mr-1\" *ngIf=\"turnOn\">\r\n        {{ 'ecash.cashback.toggle.on' | translate }}\r\n      </label>\r\n      <label class=\"cash-back-toggle-label-off text-danger font-size-12 font-weight-bold mb-0 mr-1\" *ngIf=\"!turnOn\">\r\n        {{ 'ecash.cashback.toggle.off' | translate }}\r\n      </label>\r\n      <label class=\"cashback-toggle\" [ngClass]=\"{ checked: turnOn }\">\r\n        <input\r\n          class=\"cashback-toggle-input\"\r\n          type=\"checkbox\"\r\n          role=\"switch\"\r\n          aria-labelledby=\"cashback-label\"\r\n          [disabled]=\"disableToggle\"\r\n          [(ngModel)]=\"turnOn\"\r\n          (change)=\"toggleCredit()\"\r\n        />\r\n        <span class=\"cashback-toggle-slider\"></span>\r\n      </label>\r\n    </div>\r\n  </div>\r\n  <p *ngIf=\"showError\" class=\"error text-danger pb-1\">\r\n    {{ 'ecash.cashback.toggle.error' | translate }}\r\n  </p>\r\n</div>\r\n",
                styles: [":host{width:100%}.cash-back-container{min-height:2rem}.error{font-size:.625rem;margin:0}.cashback-toggle{position:relative;display:inline-block;width:43px;height:20px;margin-bottom:0}.cashback-toggle .cashback-toggle-slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;transition:.4s;border-radius:20px}.cashback-toggle .cashback-toggle-slider:before{position:absolute;content:\"\";height:20px;width:20px;transition:.4s;border-radius:50%;box-shadow:0 0 6px rgba(0,0,0,.1607843137254902)}.cashback-toggle .cashback-toggle-input:checked+.cashback-toggle-slider:before{transform:translateX(23px)}.cashback-toggle input{opacity:0;width:0;height:0}"]
            }]
    }], function () { return [{ type: ɵngcc1.CardTokenService }]; }, { disableToggle: [{
            type: Input
        }] }); })();

class CashBackToggleModule {
}
CashBackToggleModule.ɵfac = function CashBackToggleModule_Factory(t) { return new (t || CashBackToggleModule)(); };
CashBackToggleModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: CashBackToggleModule });
CashBackToggleModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            BrowserAnimationsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CashBackToggleModule, { declarations: function () { return [CashBackToggleComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        BrowserAnimationsModule, ɵngcc4.TranslateModule]; }, exports: function () { return [CashBackToggleComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CashBackToggleModule, [{
        type: NgModule,
        args: [{
                declarations: [CashBackToggleComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    BrowserAnimationsModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [CashBackToggleComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CashBackToggleComponent, CashBackToggleModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-ecash-cash-back-toggle.js.map